var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[(_vm.loading)?[_vm._v("\n    Loading...\n  ")]:_c('div',{staticClass:"d-flex justify-center"},[_vm._l((_vm.segments[_vm.level][_vm.build.map_id][_vm.build.build_id][_vm.platform][_vm.category.title]),function(segment,index){return [_c('div',{key:segment.number,staticClass:"segment-marker mr-1",style:({ borderColor: segment.color })},[_c('router-link',{staticClass:"font-weight-bold",attrs:{"to":{
            path: '/map',
            query: {
              tab: 'runtime',
              activeCategories: [_vm.category.category],
              map_id: _vm.build.map_id,
              map_name: _vm.level,
              map_type: 0,
              [_vm.category.category + '_platform']: _vm.platform,
              [_vm.category.category + '_prevPlatform']: _vm.platform,
              [_vm.category.category + '_build']:  _vm.build.build_id,
              [_vm.category.category + '_prevBuild']:  _vm.build.build_id,
              [_vm.category.category + '_segment']: segment.number
            }
          },"target":"_blank"}},[_vm._v("\n          "+_vm._s(segment.number)+"\n        ")])],1),(index + 1 < _vm.segments[_vm.level][_vm.build.map_id][_vm.build.build_id][_vm.platform][_vm.category.title].length)?[_c('div',{key:segment.number + '_separator',staticClass:"px-2 d-flex align-center"},[_vm._v("\n          -\n        ")])]:_vm._e()]})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }